import { render, staticRenderFns } from "./ProfileContainer.vue?vue&type=template&id=4cdd66e2&scoped=true"
import script from "./ProfileContainer.vue?vue&type=script&lang=ts"
export * from "./ProfileContainer.vue?vue&type=script&lang=ts"
import style0 from "./ProfileContainer.vue?vue&type=style&index=0&id=4cdd66e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdd66e2",
  null
  
)

export default component.exports